import { frontendURL } from '../../../helper/URLHelper';
import BillingPage from './BillingPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/billing'),
    name: 'billing_dashboard',
    component: BillingPage,
    meta: {
      permissions: ['administrator'],
    },
  },
];
